import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as discussionActions from '../../actions/discussionActions';
import * as accountActions from '../../actions/accountActions';
import { ROUTES } from '../../const';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class RemoveDiscussionReveal extends Component {
  static propTypes = {
    discussion: PropTypes.object.isRequired,
    accountActions: PropTypes.object.isRequired,
    discussionActions: PropTypes.object.isRequired,
    pathname: PropTypes.string.isRequired
  };

  onRemoveTopic = () => {
    const { discussionActions, accountActions, discussion, pathname } = this.props;
    const regexp = new RegExp(ROUTES.REGEXP.DISCUSSIONS_PAGE);

    discussionActions.removeDiscussion(discussion);
    if (regexp.test(pathname)) {
      accountActions.redirectToDiscussionsList();
    }
    this.closeModal();
  };

  closeModal = () => {
    const { discussionActions } = this.props;
    discussionActions.setRemoveDiscussionRevealOpen(false);
    discussionActions.setRemoveDiscussionRevealData();
  };

  render() {
    const { discussion } = this.props;

    return (
      <Modal
        id="delete-discussion"
        title={I18n.t('discussions.modal.deleteDiscussionTitle')}
        active
        onClickOutside={this.closeModal}
        children={
          <Paragraph className="text-grey-700">
            {I18n.t('discussions.modal.deleteDiscussionBody', { discussionName: discussion.title })}
          </Paragraph>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.onRemoveTopic} primary label={I18n.t('common.delete')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    pathname: state.router.location.pathname,
    discussion: state.discussions.removeReveal.discussion
  };
}

function mapDispatchToProps(dispatch) {
  return {
    discussionActions: bindActionCreators(discussionActions, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveDiscussionReveal);
